import { FilePresent, Send } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLoaderData } from "react-router-dom";

const ChatFooter = () => {
  const { user, socket, room } = useLoaderData();
  const userID = user["userID"];
  const roomID = room["_id"];
  const roomName = room["roomName"];

  const [text, setText] = useState("");
  const [loading, setLoading] = useState("");

  const trimmedText = text.trim();
  const emptyText = trimmedText === "";

  const sendMessage = async () => {
    if (emptyText) return;
    setLoading(true);

    let message = {
      senderID: userID,
      content: trimmedText,
      roomName,
      type: "text",
      readBy: [],
    };

    await socket.emit("sendTextMessage", { roomID, message });
    setText("");
    setLoading(false);
  };

  return (
    <Box bgcolor={"white"} px={1}>
      <TextField
        placeholder="Send a message"
        size="small"
        margin="none"
        autoFocus
        fullWidth
        onChange={(e) => setText(e.target.value)}
        value={text}
        variant="standard"
        multiline
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (!emptyText) sendMessage();
          }
        }}
        slotProps={{
          input: {
            disableUnderline: true,
            endAdornment: (
              <IconButton
                disableRipple
                disabled={loading || emptyText}
                color="primary"
                size="small"
                onClick={sendMessage}
              >
                <Send fontSize="large" />
              </IconButton>
            ),
          },
        }}
      />
    </Box>
  );
};

export default ChatFooter;
